<template >
<v-responsive>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h3 class="display-3">Error</h3>

          <span class="subheading">It seems there is an error on the API.</span>

          <v-divider class="my-3"></v-divider>

          <div class="title mb-3">Please contact an administrator</div>
          <v-btn @click="$router.go(-1)">Try Again</v-btn>
          <v-btn @click="$router.push('/')">Home</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-responsive>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style>

</style>
